<template>
  <div class="pagination-component">
    <template v-if="showPagination">
      <div class="numbers" v-if="!arrowsOnly && pages">
        <button
          class="pagination" 
          v-for="(item, index) in pages"
          :key="index"
          :class="{ 'active': currentPage === item }"
          @click="changePage(item)"
        >
          {{item}}
        </button>
      </div>
      <div class="arrows">
        <button class="pagination pagination-arrow pagination-arrow-left" :disabled="firstItem" @click="changeItem(-1)">
          <Capet />
        </button>
        <button class="pagination pagination-arrow pagination-arrow-right" :disabled="lastItem" @click="changeItem(1)">
          <Capet />
        </button>
      </div>
    </template>
    
    <div class="button-container" v-if="marketplace" >
      <button class="button button-red" @click="callModal('marketplace')">
          Купить на маркетплейсах
      </button> 
    </div>
  </div>
</template>

<script>
import Capet from '@/assets/img/svg/capet.svg?inline'
import './pagination-component.sass'

export default {
  props: {
    showPagination: {
      Type: Boolean,
      default: true
    },
    arrowsOnly: {
      Type: Boolean,
      default: false
    },
    maxAtPage: {
      Type: Number,
      default: 3,
    },
    itemsCount: {
      Type: Number,
      default: 0
    },
    currentPage: {
      Type: Number,
      default: 1
    },
    currentItem: {
      Type: Number,
      default: 1
    },
    marketplace: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Capet
  },
  computed: {
    firstItem() {
      return this.currentItem === 1
    },
    lastItem() {
      return this.currentItem === this.itemsCount - (this.maxAtPage - 1)
    },
  },
  data() {
    return { 
      maxPage: 0,
      pages: [],
      
    }
  },
  methods: {
    calculatePages(maxAt, count) {
      for (let i = 0; i < Math.ceil(count/maxAt); i++)
      {
        this.pages.push(i+1);
      }
    },
    callModal(prop) {
        this.$store.commit('modal/CALL_MODAL', prop)
    },
    changeItem(num) {
      const next = this.currentItem + num;
      let nextPage = this.currentPage;
      
      if (next === this.itemsCount - (this.maxAtPage - 1) || next === 1 + this.currentPage * this.maxAtPage)    { nextPage = this.currentPage + 1 }
      else if (next < 1 + (this.currentPage - 1) * this.maxAtPage && num !== 1)                                 { nextPage = this.currentPage - 1 }

      this.$emit('changeItem', {item: next})
      this.$emit('changePage', {page: nextPage})
    },
    changePage(num) {
      this.$emit('changePage', {page: num})

      // TODO: Сделать смену активного айтема в карусели по нормальному
      // Сейчас кликается n количество раз в нужную сторону
      const activeIndex = ( 1 + (num-1) * this.maxAtPage );

      if (activeIndex > this.currentItem) {
        for (let i = this.currentItem; i <= activeIndex; i++) {
          if (i > this.itemsCount - (this.maxAtPage - 1)) continue
          setTimeout(() => this.$emit('changeItem', {item: i}), 50)
        }
      }
      else {
        for (let i = this.currentItem; i >= activeIndex; i--) {
          setTimeout(() => this.$emit('changeItem', {item: i}), 50)
        }
      }
    }
  },
  mounted() {
    this.calculatePages(this.maxAtPage, this.itemsCount)
  }
}
</script>